import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
const COLUMNS = [{
  title: 'Shop',
  links: [{
    label: 'All peptides',
    to: '/shop'
  }, {
    label: 'Recovery',
    to: '/shop'
  }, {
    label: 'Weight management',
    to: '/shop'
  }, {
    label: 'Performance',
    to: '/shop'
  }, {
    label: 'Longevity',
    to: '/shop'
  }]
}, {
  title: 'Resources',
  links: [{
    label: 'Lab testing',
    to: '/#lab'
  }, {
    label: 'The science',
    to: '/#science'
  }, {
    label: 'FAQ',
    to: '/#faq'
  }, {
    label: 'View COAs',
    to: '/#lab'
  }, {
    label: 'Storage guide',
    to: '/'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'About',
    to: '/'
  }, {
    label: 'Contact',
    to: '/'
  }, {
    label: 'Reviews',
    to: '/'
  }, {
    label: 'Journal',
    to: '/'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Terms',
    to: '/'
  }, {
    label: 'Privacy',
    to: '/'
  }, {
    label: 'Shipping',
    to: '/'
  }, {
    label: 'Returns',
    to: '/'
  }]
}];
const PAYMENTS = ['Visa', 'Mastercard', 'Amex', 'PayPal', 'Klarna'];
export function Footer() {
  return <footer className="w-full bg-foreground text-background mt-0" data-id="element-207">
      <div className="container mx-auto pt-20 pb-10" data-id="element-208">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10 lg:gap-12" data-id="element-209">
          <div className="col-span-2 md:col-span-2" data-id="element-210">
            <Logo size="lg" inverted data-id="element-211" />
            <p className="mt-5 text-sm text-background/65 leading-relaxed max-w-xs" data-id="element-212">
              Research-grade peptides at honest prices. Independently lab
              tested. Shipped from the UK.
            </p>
            <div className="mt-6 flex items-center gap-2 flex-wrap" data-id="element-213">
              {PAYMENTS.map(p => <span key={p} className="text-[10px] font-mono uppercase tracking-wider px-2.5 py-1 rounded border border-background/15 text-background/65" data-id="element-214">
                  {p}
                </span>)}
            </div>
          </div>

          {COLUMNS.map(col => <div key={col.title} data-id="element-215">
              <h4 className="text-[11px] uppercase tracking-wider font-medium text-background/50 mb-4" data-id="element-216">
                {col.title}
              </h4>
              <ul className="space-y-2.5" data-id="element-217">
                {col.links.map(l => <li key={l.label} data-id="element-218">
                    <Link to={l.to} className="text-sm text-background/85 hover:text-background transition-colors" data-id="element-219">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-16 pt-8 border-t border-background/10" data-id="element-220">
          <p className="text-[12px] text-background/55 leading-relaxed max-w-3xl" data-id="element-221">
            <span className="font-medium text-background/75" data-id="element-222">
              For research purposes only.
            </span>{' '}
            Products sold on this site are intended exclusively for in-vitro
            laboratory and research use. They are not for human consumption,
            medical use, or veterinary use. You must be 18 or older to purchase.
            By using this site you agree to our Terms.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-[12px] text-background/55" data-id="element-223">
            <span data-id="element-224">
              © {new Date().getFullYear()} peptides.ml — all rights reserved.
            </span>
            <span className="font-mono" data-id="element-225">Made in the UK 🇬🇧</span>
          </div>
        </div>
      </div>
    </footer>;
}